export default function IconMenu({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M24 16.75H0V15.25H24V16.75ZM24 8.75H0V7.25H24V8.75Z" fill="currentColor"/>
    </svg>
  );
}
